import { getUsersFromClient, searchUsersFromClient, User } from '~/pages/api/users';
import { useIncrementalQuery, UseIncrementalQueryResult } from '~/queries';

const KEY = 'users-search';
const DEFAULT_RESULT_LIMIT = 10;
const MINIMUM_SEARCH_TERM_LENGTH = 4;

export function useUsersSearch(
   searchTerm: string,
   limit: number = DEFAULT_RESULT_LIMIT,
   prefillResults = true
): UseIncrementalQueryResult<User[]> {
   return useIncrementalQuery([KEY, searchTerm], async page => {
      if (searchTerm.length < MINIMUM_SEARCH_TERM_LENGTH && !prefillResults) {
         return { data: [], hasMore: false, page: 1 };
      }

      if (searchTerm.length >= MINIMUM_SEARCH_TERM_LENGTH) {
         const { results: data, moreResults: hasMore } = await searchUsersFromClient(searchTerm, {
            page: page,
            limit: limit,
         });
         return { data, hasMore, page };
      }

      const data = await getUsersFromClient({ limit: limit, offset: limit * (page - 1) });
      return { data, page, hasMore: data.length === limit };
   });
}
